module.exports = __webpack_public_path__ + "img/fig08.f0231be5.jpg";